import { css } from 'emotion';
import { styled } from '@withjoy/joykit';

export namespace styles {
  export const createWeddingWrapper = css({
    display: 'flex',
    flexDirection: 'column'
  });

  export const animate = css({
    display: 'flex',
    justifyContent: 'center'
  });
}

export const FlexCenterWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100vh; /* 100% causes firefox to break */
`;
